import { render, staticRenderFns } from "./KasPiutang.vue?vue&type=template&id=724ce70a"
import script from "./KasPiutang.vue?vue&type=script&lang=js"
export * from "./KasPiutang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports